<template>
  <div class="catalog-view-switch">
    <sf-button
      variant="tertiary"
      aria-label="grid view button"
      class="catalog-view-button"
      @click="catalogViewType = CatalogView.grid"
    >
      <icons-icon-grid-view :size="size" class="icon" />
    </sf-button>
    <sf-button
      variant="tertiary"
      aria-label="list view button"
      class="catalog-view-button"
      @click="catalogViewType = CatalogView.list"
    >
      <icons-icon-list :size="size" class="icon" />
    </sf-button>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from "vue";
import { SfIconSize } from "@zaprooecommerce/storefront-ui-vue";
import { CatalogView } from "~/modules/user-settings/types";

defineProps({
  size: {
    type: String as PropType<`${SfIconSize}`>,
    default: SfIconSize.base,
  },
});

const { catalogViewType } = useUserSettings();
</script>

<style lang="scss">
.catalog-view-button {
  @apply p-2 hover:bg-neutral-100 active:bg-neutral-100 md:h-9 md:w-9;
}
</style>
